export enum SubscriptionOptions {
    IdleAccount = 'idle_account',
    ExpiringMemberships = 'expiring_memberships',
    AgingEquipment = 'aging_equipment',
    UnsoldEstimates = 'unsold_estimates',
    Other = 'other',
    RecurringService = 'recurring_service',
    Newsletter = 'newsletter',
    ThankYou = 'thank_you',
    CustomerWelcome = 'customer_welcome',
    MarketToLeads = 'market_to_leads',
}
